const Links = [
  { display: 'Home', link: '/' },
  { display: 'About me', link: '/about' },
  { display: 'Projects', link: '/projects' },
  // { display: 'Blogs', link: '/blogs' },
];

export default Links;
